import React from "react";
import TranslatedString from "Components/TranslatedString";
import { bytesToGiB } from "Utils/bytesFormats";

import { t } from "i18next";
import cx from "classnames";
import s from "./limitsSettings.scss";

export default class Limits extends React.Component {
  render() {
    const { user } = this.props;

    return (
      <div className={s.limits}>
        <div className="sectionSP">
          <div className="infoSectionSP">
            <div className="settingTitle">{t("settings.sections.customerLimits.title")}</div>
            <div className="sectionDesc" />
          </div>
          <div className="formsSectionSP">
            {(user.type === "Customer" || user.type === "Manager") && (
              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.max.domains")}</div>
                <div className={s.dataRecapt}>{user.max_domains}</div>
              </div>
            )}
            <div className={cx("inputFull2", s.sectionRecap)}>
              <div className={s.labelRecapt}>{t("detailInfo.label.max.accounts8")}</div>
              <div className={s.dataRecapt}>{user.max_email_accounts}</div>
            </div>
            <div className={cx("inputFull2", s.sectionRecap)}>
              <div className={s.labelRecapt}>{t("detailInfo.label.max.accounts25")}</div>
              <div className={s.dataRecapt}>{user.max_email_accounts_25gb}</div>
            </div>
            <div className={cx("inputFull2", s.sectionRecap)}>
              <div className={s.labelRecapt}>{t("detailInfo.label.max.archive")}</div>
              <div className={s.dataRecapt}>{user.max_email_accounts_archive}</div>
            </div>
            <div className={cx("inputFull2", s.sectionRecap)}>
              <div className={s.labelRecapt}>{t("detailInfo.label.max.accountsSize")}</div>
              <div className={s.dataRecapt}>{bytesToGiB(user.max_email_quota, true)}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
